import { render, staticRenderFns } from "./mc-clicker.tests.vue?vue&type=template&id=508a4f4e&scoped=true"
import script from "./mc-clicker.tests.vue?vue&type=script&lang=ts"
export * from "./mc-clicker.tests.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508a4f4e",
  null
  
)

export default component.exports